import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export interface RefusalInvoice {
  id: number;
  total: number;
  paid_total: number;
  refunded_total: number;
  refund_pending_total: number;
  cancel_total: number;
  refund_due_after: number;
  available_refund_after: number;
  items: Array<{ product_id: number; article: string; description: string; quantity: number; price: number }>;
}
export interface OrderRefusalPreview {
  order_id: number;
  is_canceled: boolean;
  reason: string;
  version: string;
  blocked_reason: string | null;
  needs_confirmation: boolean;
  paid_total: number;
  refunded_total: number;
  refund_due_total: number;
  available_refund_total: number;
  wallet_credited_total?: number;
  invoices: RefusalInvoice[];
}
export interface OrderRefusalRequest { request_id: string; expected_version: string; reason: string; }

@Injectable({ providedIn: 'root' })
export class OrderRefusalService {
  constructor(private http: HttpClient) {}
  preview(id: number) { return this.http.get<OrderRefusalPreview>(`${environment.BACKEND}/order/${id}/refusal`); }
  apply(id: number, payload: OrderRefusalRequest) {
    return this.http.post<{ order_id: number; replayed: boolean }>(`${environment.BACKEND}/order/${id}/refusal`, payload);
  }
}
